import React, { useContext, useCallback } from 'react';
import _ from 'lodash';
import { BreakpointTrackerContext } from '@jutro/layout';
import { wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { withRouter } from 'react-router-dom';
import { screenReaderAnnounce } from 'premier-capability-hooks';
import { useTranslator } from '@jutro/locale';

import metadata from './RiskInformationComponent.metadata.json5';
import styles from '../../../pages/MarPle/MarPlePage.module.scss'
import messages from './RiskInformationComponent.messages'; 

function RiskInformationComponent(props) {

    const { submissionVM, updateWizardData, pathUpdated } = props;
    const breakpoint = useContext(BreakpointTrackerContext);
    const { onValidate } = useValidation('RiskInformationComponent');
    const modelVM = _.get(submissionVM, pathUpdated)
    const translator = useTranslator();

    modelVM.value.isValidationReq = true

    // eslint-disable-next-line react-hooks/exhaustive-deps
    const overrideProps = {
        '@field': {
            showRequired: true,
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top'
        },
        isthiuseforguifiscchaFie: {
             visible: !_.isUndefined(modelVM.value.isVesuseforRecPriPonlFie) && !modelVM.value.isVesuseforRecPriPonlFie
        },
        ifnoexpFie: {
            visible: !_.isUndefined(modelVM.value.isVesuseforRecPriPonlFie) && !modelVM.value.isVesuseforRecPriPonlFie
            && !_.isUndefined(modelVM.value.isthiuseforguifiscchaFie) && !modelVM.value.isthiuseforguifiscchaFie
        },
        ifYesexpwhehowlonawhyFie: {
            visible: !_.isUndefined(modelVM.value.isthiboalivaboasasresFie) && modelVM.value.isthiboalivaboasasresFie
        },
        ifyespleprodetFie: {
            visible: !_.isUndefined(modelVM.value.hasanyinsevecandecforFie) && modelVM.value.hasanyinsevecandecforFie
        },
        doyouoranylivundyoothFie: {
            visible: _.get(submissionVM, 'baseData.baseState_Ext.value.code') === 'QC' && !_.isUndefined(_.find(submissionVM.baseData.account_Ext.accountLocations_Ext.value, (actlct) => actlct.state === 'QC')),
            required: _.get(submissionVM, 'baseData.baseState_Ext.value.code') === 'QC' && !_.isUndefined(_.find(submissionVM.baseData.account_Ext.accountLocations_Ext.value, (actlct) => actlct.state === 'QC'))
        }
    };


    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
        },
        resolveClassNameMap: styles,
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.componentContent, _.get(submissionVM, pathUpdated), id, path, overrideProps),
        [overrideProps, pathUpdated, submissionVM]
    );

    const handleValueChange = useCallback(
        (value, changedPath) => {
            const fullPath = `${pathUpdated}.${changedPath}`;

            _.set(submissionVM, `${fullPath}`, value);
            updateWizardData(submissionVM);
            
            if(changedPath === 'isthiuseforguifiscchaFie') {
                submissionVM.lobData.recMarLine.coverables.marinePleasurecraft.skipFishCharterSupple.value.isValidationReq = value
            }

            updateWizardData(submissionVM);
            screenReaderAnnounce(translator(messages.newFieldsPopulated));
        },
        [pathUpdated, submissionVM, translator, updateWizardData]
    );

    return (
        <ViewModelForm
            uiProps={metadata.componentContent}
            model={modelVM}
            resolveValue={readValue}
            overrideProps={overrideProps}
            onValidationChange={onValidate}
            onValueChange={handleValueChange}
            callbackMap={resolvers.resolveCallbackMap}
            componentMap={resolvers.resolveComponentMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    );


}

RiskInformationComponent.propTypes = wizardProps;
export default withRouter(RiskInformationComponent);
